module.exports = __webpack_public_path__ + "img/snowy-2.d103c77c.svg";